import Favorite from "@/components/icons/Favorite";
import Button from "@/components/ui/Button";
import useSelection from "@/lib/centra/hooks/useSelection/useSelection";
import useWishlist from "@/lib/centra/hooks/useWishlist";
import { events } from "@frend-digital/events";
import clsx from "clsx";
import styles from "./index.module.css";
type Props = {
  id: string;
  className?: string;
  isDark?: boolean;
  variant?: "large" | "default";
};

const WishlistToggle = ({
  id,
  className,
  isDark,
  variant = "default",
}: Props) => {
  const { toggle, includes } = useWishlist();
  const { data } = useSelection();
  return (
    <Button
      mode="unset"
      onClick={e => {
        e.stopPropagation();
        if (id) {
          toggle(id)();

          if (!includes(id)) {
            events.dispatch("add_to_wishlist", data, {
              dispatcher: "centra",
              item_id: id,
            });
          }
        }
      }}
    >
      <Favorite
        className={clsx(
          className,
          styles.wishlistToggle,
          variant === "large" && styles.wishlistToggleLarge,
        )}
        isDark={isDark ?? includes(id) ?? false}
        isActive={includes(id)}
      />
    </Button>
  );
};

export default WishlistToggle;
